import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SlateToggleGroup from '../Shared/SlateToggleGroup';

var ListViewTypeSelector = function(props) {
  var types = props.types;
  var listViewType = props.listViewType;
  var onChange = props.onChange;
  var disabled = props.disabled;
  var customLabel = props.customLabel;
  var t = useTranslation().t;

  var options = Object.values(types).map(function(type) {
    return {
      value: type,
      label: t('settings:' + type),
    };
  });

  return (
    <SlateToggleGroup
      label={customLabel || t('settings:whatDataWouldYouLike')}
      options={options}
      value={listViewType}
      onChange={onChange}
      disabled={disabled}
    />
  );
};

ListViewTypeSelector.propTypes = {
  types: PropTypes.object.isRequired,
  listViewType: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  customLabel: PropTypes.string,
};

export default ListViewTypeSelector;
